
import React, { Component } from 'react';
import moment from 'moment'
import PropTypes from 'prop-types';
import { Form, Cascader } from 'antd'
import { formValidator, numberValidator, authValidator, outputClassValidator, options, _tableFormProps } from "./config";

import { component_tool, framework_tool } from '@/tool'
import $$ from 'cmn-utils';
let { WizAvatarUpload, ossFileUtils } = framework_tool
let {
    WizButton,
    WizSelect,
    WizTooltip,
    WizInput,
    WizIcon,
    WizSwitch,
    WizDatePicker,
    WizRow,
    WizCol,
    WizRadio,
    WizDivider,
    WizCheckbox,
    WizInputNumber
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option
let OptGroup = WizSelect.OptGroup
import { WizTableForm, WizAuthority } from '@/containers/common';


/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class TaskForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            propsInit: false,
            bizChange: false,
            date: new Date().getTime()
        }
    }

    componentDidMount() {
        let { data, form } = this.props;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true
    }


    /**
     * 表单基础内容
     */
    _base() {
        const { data, form } = this.props;
        let { getFieldDecorator } = form;
        let { allowOrder, bizChange, date } = this.state;
        //  }
        return [
            <Item label="名称" >
                {getFieldDecorator('name', {
                    rules: [{ required: true, message: "请输入名称" }],
                    initialValue: data.name,
                })(<WizInput maxLength={30} placeholder='请输入名称,最多30字' />)}
            </Item>,
            <Item label="开始时间">
                {getFieldDecorator('startDate', {
                    rules: [{ required: true, message: '请选择开始时间', }],
                    initialValue: data.startDate && moment(data.startDate, 'YYYY-MM-DD HH:mm:ss') || null
                })(<WizDatePicker key='startDate' showTime placeholder="请选择开始时间" format="YYYY-MM-DD HH:mm" />)}
            </Item>,
            <Item label="结束时间">
                {getFieldDecorator('endDate', {
                    rules: [{ required: true, message: '请选择结束时间', }],
                    initialValue: data.endDate && moment(data.endDate, 'YYYY-MM-DD HH:mm:ss') || null
                })(<WizDatePicker key='endDate' showTime placeholder="请选择结束时间" format="YYYY-MM-DD HH:mm" />)}
            </Item>,
            <Item label="封面设置" >
                {getFieldDecorator('coverImg', {
                    initialValue:
                        (data && data.img) ? [
                            { fileId: data.img }
                        ] : []
                })(
                    <WizAvatarUpload
                        key={data && data.img || ''}
                        accept={'.jpg, .jpeg, .png'}
                        listType={'picture-card'}
                        aspectRatio={800 / 450}
                        beforeUpload={(file) => {
                            let result = true;
                            const isLt1M = file.size / 1024 / 1024 < 0.195;
                            if (file.type.indexOf('image/') == -1) {
                                Wizmessage.error('只能上传图片类型,请重新选择!');
                                result = false;
                            } else if (!isLt1M) {
                                Wizmessage.error('图片不得超过200k!');
                                result = false;
                            }
                            return result;
                        }}
                    />
                )}
            </Item>,

            <Item label="重要程度">
                {getFieldDecorator('importance', {
                    initialValue: data.state || 0
                })(
                    <WizRadio.Group>
                        <WizRadio value={1}>重要</WizRadio>
                        <WizRadio value={0}>一般</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item>,
            <Item label="启用">
                {getFieldDecorator('enable', { initialValue: data.enable })(
                    <WizCheckbox
                    //key={this.resetTime + key} 
                    //value={key} title={this.checks[key].title}
                    //    defaultChecked={this.state.record[key]}
                    >
                        启用
                    </WizCheckbox>
                )}
            </Item>

        ]
    }
    handleReset = () => {
        //重置表单
        this.setState({
            propsInit: false,
            bizChange: false,
            date: new Date().getTime()
        })
        this.props.form.resetFields();
    };


    /**
    * 处理表单提交事件
    */
    handleSubmit = e => {
        const { data } = this.state
        let { submit } = this.props;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let coverImg = values['coverImg']
                values['id'] = data && data['id'] || null
                values['startDate'] = values['startDate'] && values['startDate'].format('YYYY-MM-DD HH:mm:ss')
                values['endDate'] = values['endDate'] && values['endDate'].format('YYYY-MM-DD HH:mm:ss')
                if (coverImg && coverImg.length) {
                    values['img'] = coverImg[0]['fileId']
                    delete values['coverImg']
                }
                submit && submit(values)
            }
        });
    };

    render() {

        let { data } = this.props;
        let outputClass = this.props.form.getFieldValue("outputClass")
        let extOptions = [];
        if (outputClass && outputClass instanceof Array && outputClass.length > 0) {
            outputClass.map(p => extOptions.push(p))
        }
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            ref: 'form',
        };
        return (
            <WizForm
                {...formItemLayout}
                onSubmit={this.handleSubmit}
            >
                {this._base()}
            </WizForm>
        )

    }
}

export default WizForm.create()(TaskForm);

/**
 * 默认值
 */
TaskForm.defaultProps = {
    // title: '新增题目',
    data: {},
    selects: []
}

/**
 * props入参校验
 */
TaskForm.propTypes = {
}

